import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Params } from "@angular/router";
import { Observable } from "rxjs";
import { APIUrl } from "src/app/features-common/constants/APIUrls";
import { BaseService } from "src/app/framework/services/base.service";
import { environment } from "src/environments/environment";

@Injectable()
export class RetailerService extends BaseService {
  constructor(private http: HttpClient) {
    super();
  }

  getConfigValues(): Observable<any> {
    let params = new HttpParams().set("config_name", "BusinessType");
    // return this.http.get(APIUrl.congifValues, { params });
    return this.httpService.getRetailerData(APIUrl.congifValues, params);
  }

  getActiveSalesRepresentatives(): Observable<any> {
    return this.httpService.get(APIUrl.getSalesReps);
  }
  getRetailerDetails(): Observable<any> {
    return this.httpService.get(APIUrl.allRetailers);
  }
  getRetailerBusinessNames(): Observable<any> {
    return this.httpService.get(APIUrl.retailerBusinessNames);
  }
  getActivePricelists(): Observable<any> {
    return this.httpService.get(APIUrl.retailerpricelists);
  }
  getsalesPricelists(): Observable<any> {
    return this.httpService.get(APIUrl.salesrepspricelists);
  }
  getRoles(): Observable<any> {
    return this.httpService.get(APIUrl.roles);
  }
  getBusinessnames(): Observable<any> {
    return this.httpService.get(APIUrl.businessNames);
  }
  addNewRetailer(params: Params): Observable<any> {
    return this.httpService.post(APIUrl.allRetailers, params);
  }

  addRetailerPaymentInfo(params: Params): Observable<any> {
    return this.httpService.put(APIUrl.allRetailers, params);
  }

  getSelectedRetailer(id: number): Observable<any> {
    return this.httpService.get(`${APIUrl.getRetailer}/${id}`);
  }
  getPricelists(params: Params): Observable<any> {
    return this.httpService.getParams(APIUrl.salesrepPricelist, params);
  }
  
  getretailerGrid(): Observable<any> {
    return this.httpService.get(APIUrl.retailerGrid);
  }
  getPaymentHistory(httpParams): Observable<any> {
    //let params = httpParams;
    //console.log(httppPa);
    return this.httpService.getParams(APIUrl.paymentHistory, httpParams);
  }

  getCloseAccountRequests(): Observable<any> {
    let url = APIUrl.getCloseRequest;
    return this.httpService.get(url);
  }

  notifyRetailer(amount, retailerId): Observable<any> {
    let url = APIUrl.notifyRetailer;
    let params = new HttpParams()
      .set("amount", amount)
      .set("retailerId", retailerId);
    return this.httpService.getParams(url, params);
  }
  closeRetailerAccount(retailerId, message, isSendMessage): Observable<any> {
    let url = APIUrl.finalizeAccountClose;
    let params = new HttpParams()
      .set("message", message)
      .set("retailerId", retailerId)
      .set("sendMessage", isSendMessage);
    return this.httpService.getParams(url, params);
  }
  cancelRetailerCloseAccount(retailerId): Observable<any> {
    let url = APIUrl.requestUndoCloseAccount;
    let params = new HttpParams()
      .set("retailerId", retailerId)
    return this.httpService.getParams(url, params);
  }

  getAllRetailerAccounts(): Observable<any> {
    let url = APIUrl.searchAllRetailer;
    return this.httpService.get(url);
  }
  getRetailerByName(retailerName): Observable<any> {
    let url = APIUrl.searchAllRetailer;
    let params = new HttpParams().set("retailerName", retailerName);
    return this.httpService.getParams(url, params);
  }

  getRetailersLinkedById(id: any): Observable<any> {
    let url = APIUrl.getRetailerLinked;
    let params = new HttpParams().set("retailerId", id);
    return this.httpService.getParams(url, params);
  }

  linkRetailerAccounts(formData): Observable<any> {
    let url = APIUrl.linkRetailer;
    return this.httpService.post(url, formData);
  }

  UnLinkRetailerAccount(linkedRetailerAccountId): Observable<any> {
    let url = `${APIUrl.unlinkRetailer}/${linkedRetailerAccountId}`;
    return this.httpService.delete(url);
  }

  pricelistdownloadProdcuts(pricelistname) {
    let url = `${environment.hostUrl}:${environment.port}/${APIUrl.pricelistdownloadProdcuts}/${pricelistname}`;
    return this.http.get(url, { responseType: "blob" as "json" });
  }
  
  addNewComment(params: Params): Observable<any> {
    return this.httpService.post(APIUrl.postsalesRepComments, params);
  }
  editComment(params: Params): Observable<any> {
    return this.httpService.put(APIUrl.postsalesRepComments, params);
  }
  getComment(id: number): Observable<any> {
    return this.httpService.get(`${APIUrl.salesRepComments}/${id}`);
  }
  deleteComment(id: number): Observable<any> {
    return this.httpService.delete(`${APIUrl.salesRepComments}/${id}`);
  }
  getComments(params): Observable<any> {
    return this.httpService.getParams(APIUrl.salesRepretailerComments, params);
  }

  getRetailerRequestSubmissions():Observable<any>{
    return this.httpService.get(APIUrl.becomeRetailers)
  }
}
